<section class="registration-product-confirmation-code">
	<p class="registration-product-confirmation-code__text">
		Введите код, отправленный Вам на мобильный телефон
	</p>

	<app-splitted-input
		class="registration-product-confirmation-code__confirmation-code"
		[groupCount]="1"
		[groupSize]="4"
		[inputMode]="smsCodeInputMode"
		[formControl]="confirmationCodeControl"
	></app-splitted-input>

	<ng-container
		[ngTemplateOutlet]="simpleLink"
		[ngTemplateOutletContext]="{ countDown: (countDown$ | async) }"
	></ng-container>
</section>

<ng-template
	#simpleLink
	let-countDown="countDown"
>
	<button
		class="registration-product-confirmation-code__restart-button"
		type="button"
		[disabled]="countDown > 0"
		(click)="restartTimer()"
	>
		Получить код повторно
		@if (countDown > 0) {
			<span>({{ countDown }} сек)</span>
		}
	</button>
</ng-template>
